import React, {
  Suspense,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { gsap } from "gsap";
import "./styles.scss";
import { Route, Switch, Redirect } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import LoadingTaken from "./components/LoadingToken";
import { loadReCaptcha } from "react-recaptcha-google";

loadReCaptcha();

const HomePage = React.lazy(() => import("./pages/Home"));
const AgentPage = React.lazy(() => import("./pages/Agent"));
const NotFound = React.lazy(() => import("./pages/NotFound"));

export default function App() {
  return (
    <BrowserRouter>
      <Route
        render={(props) => (
          <Switch>
            <Route path={"/"} exact>
              <Redirect to={"/home"} />
            </Route>
            <Route path={"/home"} exact>
              <Suspense
                fallback={
                  <LoadingTaken isLoading={true} style={{ height: "100vh" }} />
                }
              >
                <HomePage />
              </Suspense>
            </Route>
            <Route path={"/agent"} exact>
              <Suspense
                fallback={
                  <LoadingTaken isLoading={true} style={{ height: "100vh" }} />
                }
              >
                <AgentPage />
              </Suspense>
            </Route>
            <Route component={NotFound} />
          </Switch>
        )}
      />
    </BrowserRouter>
  );
}
